import React from "react";

import { BANNER } from "../accessoryCopy";

const BANNER_IMAGE = "/assets/images/accessories/accessories-banner.jpg";

const AccessoriesBanner = () => (
  <section className="acc-banner">
    <img
      className="acc-banner-image"
      src={BANNER_IMAGE}
      alt=""
      aria-hidden="true"
    />

    <span className="acc-banner-scrim" aria-hidden="true" />

    <div className="acc-banner-copy">
      <p className="acc-banner-eyebrow">{BANNER.eyebrow}</p>

      <h1 className="acc-banner-title">{BANNER.title}</h1>

      <p className="acc-banner-blurb">{BANNER.blurb}</p>
    </div>
  </section>
);

export default AccessoriesBanner;
